import { Container, Row, Col } from 'reactstrap';
import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';

import Canonical from 'Components/Canonical';
import {
  PageTitle,
  GoldAd,
  SilverAd,
  PlaceTop,
  PromotionSticker,
} from 'Components/LandingPages/Promotion';

import { getRouterBasePath } from 'utils/meta';

import { deviceParams } from 'store/reselect';

const Breadcrumbs = dynamic(
  () => import('Components/Dumb/Breadcrumbs').then(module => module.default),
  { ssr: true },
);

const Promotion = ({
  withoutTitle,
  withoutBreadcrumbs,
  inShoppingCardPage,
}) => {
  const { deviceType } = useSelector(deviceParams());
  const { title, description } = getRouterBasePath('/promotion');

  return (
    <>
      <Canonical />
      <NextSeo title={title} description={description} />
      <Container>
        <Row>
          <Col
            xs={12}
            sm={12}
            lg={{ offset: 1, size: 10 }}
            xl={{ offset: 1, size: 10 }}
          >
            {!withoutBreadcrumbs && <Breadcrumbs roadMap="home.promotion" />}
            {!withoutTitle && <PageTitle />}
          </Col>
        </Row>
      </Container>
      <section className="bg-light-section with-margin-negative">
        <GoldAd deviceType={deviceType} />
      </section>
      <SilverAd deviceType={deviceType} />
      <section className="bg-light-section with-margin-negative">
        <PlaceTop deviceType={deviceType} />
      </section>
      <PromotionSticker
        deviceType={deviceType}
        inShoppingCardPage={inShoppingCardPage}
      />
    </>
  );
};

export default Promotion;
